import { render, staticRenderFns } from "./ActionPermissionsTab.vue?vue&type=template&id=e683a0d6"
import script from "./ActionPermissionsTab.vue?vue&type=script&lang=ts"
export * from "./ActionPermissionsTab.vue?vue&type=script&lang=ts"
import style0 from "./ActionPermissionsTab.vue?vue&type=style&index=0&id=e683a0d6&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports